import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, useTheme } from "@mui/material";
import LanguageSwitcher from "./LanguageSwitcher";
import { useTranslation } from "react-i18next";

const TARGET_DATE = new Date("2026-03-28T23:59:00+02:00");

const MaintenancePage = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  function getTimeLeft() {
    const now = new Date();
    const difference = TARGET_DATE - now;
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
    // eslint-disable-next-line
  }, []);

  if (Object.keys(timeLeft).length === 0) {
    return (
      <Box sx={{ mt: 8, textAlign: "center" }}>
        <img
          src="/logo.png"
          alt="In Cooking logo"
          style={{ width: 120, marginBottom: 24 }}
        />
        <Typography variant="h3">{t("available")}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 6,
      }}
    >
      <LanguageSwitcher />
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, sm: 4 },
          maxWidth: 430,
          width: "90vw",
          textAlign: "center",
          borderRadius: 4,
        }}
      >
        <img
          src="/logo.png"
          alt="In Cooking logo"
          style={{
            width: 100,
            marginBottom: 16,
            filter: "drop-shadow(0 2px 6px rgba(30,30,30,0.09))",
          }}
        />
        <Typography variant="h4" color="primary" gutterBottom sx={{ fontWeight: 700 }}>
          {t("maintenance_title")}
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, fontSize: 17 }}>
          {t("message")}
        </Typography>
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {t("countdownLabel")}
        </Typography>
        <Typography
          variant="h5"
          color="secondary"
          sx={{ mb: 2, letterSpacing: 1, fontWeight: 500 }}
        >
          {timeLeft.days} {t("days")},&nbsp;
          {timeLeft.hours} {t("hours")},&nbsp;
          {timeLeft.minutes} {t("minutes")},&nbsp;
          {timeLeft.seconds} {t("seconds")}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary", mt: 3 }}>
          {t("thankyou")}
        </Typography>
      </Paper>
      <Box sx={{ mt: 4, color: "text.secondary" }}>
        &copy; {new Date().getFullYear()} In Cooking
      </Box>
    </Box>
  );
};

export default MaintenancePage;
